import { render, staticRenderFns } from "./SubgroupDetail.vue?vue&type=template&id=7258b34e"
import script from "./SubgroupDetail.vue?vue&type=script&lang=js"
export * from "./SubgroupDetail.vue?vue&type=script&lang=js"
import style0 from "./SubgroupDetail.vue?vue&type=style&index=0&id=7258b34e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports